"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
var _member_label = require("@/api/member/member_label.js");
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberListByLabel',
  props: {
    labelData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      labelInfo: this.labelData,
      // 搜索表单数据
      searchForm: {
        mobilePhone: '',
        registerType: '',
        cardNo: '',
        regTimeRange: []
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 图片路径
      imgPath: process.env.VUE_APP_COMMENT_IMAGE_URL // 图片路径
    };
  },
  created: function created() {
    // 初始化时获取会员列表数据
    this.fetchMemberList();
  },
  methods: {
    // 根据appid从openIds数组中获取openid
    getOpenId: function getOpenId(openIds, appid) {
      if (!openIds || !Array.isArray(openIds)) return '';
      var item = openIds.find(function (item) {
        return item.appid === appid;
      });
      return item ? item.openid : '';
    },
    // 解绑微信openid
    unbindOpenId: function () {
      var _unbindOpenId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(openid, userId) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (openid) {
                _context2.next = 1;
                break;
              }
              this.$message.error('请选择要解绑的openid');
              return _context2.abrupt("return");
            case 1:
              if (userId) {
                _context2.next = 2;
                break;
              }
              this.$message.error('请选择要解绑的会员');
              return _context2.abrupt("return");
            case 2:
              this.$confirm('确定要解绑该openid吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, _t;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 1;
                      return (0, _memberManagement.unbindOpenId)(openid, userId);
                    case 1:
                      response = _context.sent;
                      if (response.code === 0) {
                        _this.$message.success('解绑成功');
                        _this.fetchMemberList();
                      } else {
                        _this.$message.error(response.message || '解绑失败');
                      }
                      _context.next = 3;
                      break;
                    case 2:
                      _context.prev = 2;
                      _t = _context["catch"](0);
                      console.error('解绑openid失败:', _t);
                      _this.$message.error('解绑openid失败');
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 2]]);
              }))).catch(function () {
                _this.$message.info('已取消解绑');
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function unbindOpenId(_x, _x2) {
        return _unbindOpenId2.apply(this, arguments);
      }
      return unbindOpenId;
    }(),
    // 处理头像URL，确保正确的前缀
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      // 如果已经是http开头，直接返回
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      // 否则添加前缀
      return this.imgPath + userpic;
    },
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchMemberList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm = {
        mobilePhone: '',
        registerType: '',
        cardNo: '',
        regTimeRange: []
      };
      this.currentPage = 1;
      this.fetchMemberList();
    },
    // 获取会员列表
    fetchMemberList: function () {
      var _fetchMemberList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loading = true;
              _context3.prev = 1;
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                labelId: this.labelInfo.fnId,
                // 添加标签ID参数
                page: this.currentPage,
                limit: this.pageSize
              }); // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                params.regTimeStart = this.searchForm.regTimeRange[0];
                params.regTimeEnd = this.searchForm.regTimeRange[1];
              }
              // 删除regTimeRange字段，因为后端不需要这个字段
              delete params.regTimeRange;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context3.next = 2;
              return (0, _member_label.getMemberListByLabelId)(params);
            case 2:
              response = _context3.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取会员列表失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t2 = _context3["catch"](1);
              console.error('获取会员列表失败:', _t2);
              this.$message.error('获取会员列表失败');
            case 4:
              _context3.prev = 4;
              this.loading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchMemberList() {
        return _fetchMemberList.apply(this, arguments);
      }
      return fetchMemberList;
    }(),
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchMemberList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchMemberList();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取注册方式文本
    getRegisterTypeText: function getRegisterTypeText(type) {
      var typeMap = {
        0: '系统注册',
        2: '点餐',
        3: '口碑',
        4: '社交',
        5: '支付宝'
      };
      return typeMap[type] || '未知';
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前的清理工作
    console.log('MemberListByLabel component is being destroyed');
  }
};